import { useQuery } from '@tanstack/react-query';
import { languagesApi } from '@api/languages';
import type { Language } from './types';

/**
 * Aktif içerik dilleri — içerik i18n UX'inde dil seçici / varyant paneli
 * tarafından paylaşılan kaynak. Diller nadiren değişir; uzun stale süresi.
 */
export function useActiveLanguages() {
  return useQuery({
    queryKey: ['languages', 'active'],
    queryFn: () => languagesApi.list(true),
    staleTime: 5 * 60_000,
  });
}

/** Varsayılan dili (veya ilk aktifini) döndürür — create formu ön-seçimi için. */
export function pickDefaultLanguage(languages: readonly Language[]): Language | undefined {
  return languages.find((l) => l.isDefault) ?? languages[0];
}
